import { useContext } from 'react';

import { ConfirmCtx } from '@app/providers/NewConfirmProvider/NewConfirmContext';

export const useConfirmNew = () => {
  const context = useContext(ConfirmCtx);

  if (!context) {
    throw new Error('useConfirmNew must be used within a NewConfirmProvider');
  }

  return context;
};
